'use client'
import { useMemo } from 'react'
import { PrismicText } from '@prismicio/react'
import { useScrollspyWithManualControl } from '@/hooks/useScrollspyWithManualControl'

type DataObject = Record<string, any>
type ItemObject = Record<string, any>

const BlogDetailsSideBar = ({ data }: { data: DataObject }) => {
  // Get section IDs for scrollspy
  const sectionIds = useMemo(
    () => data.body.map((contentItem: ItemObject) => contentItem.primary.section_id),
    [data.body],
  )

  // Use the combined scrollspy + manual control hook
  const { activeItemId, handleItemClick } = useScrollspyWithManualControl({
    items: sectionIds,
    offset: 100,
  })

  return (
    <div className="blog-sidebar-content sticky top-[100px] rounded-md border border-secondary-gray-100 px-4 py-6">
      <div className="toc-heading max-h-[calc(100vh-300px)] overflow-y-auto">
        <p className="font-halyardDisplay text-xl">Table of Contents</p>
        <ul>
          {data.body.map((contentItem: ItemObject, index: number) => {
            const sectionId = contentItem.primary.section_id
            const isActive = activeItemId === sectionId
            return (
              <li key={`section-${index}`} className={isActive ? 'active' : ''}>
                <a
                  href={`#${sectionId}`}
                  onClick={(e) => {
                    e.preventDefault()
                    handleItemClick(sectionId)
                  }}
                  className="cursor-pointer">
                  <span className="toc-item">
                    <PrismicText field={contentItem?.primary?.content_title} />
                  </span>
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default BlogDetailsSideBar
